// src/sections/admin/view/index.tsx
import WorkspaceGeneralView from 'src/sections/workspaces/view/general';
import AdminUsersSection from 'src/sections/overview/dashboards/views/admin/users';
import ListIntegrations from 'src/sections/overview/dashboards/views/admin/sso-integrations/view/list';

export type AdminTab = 'cockpit' | 'users' | 'sso';

interface Props {
  tab: AdminTab;
}

export default function AdminView({ tab }: Props) {
  if (tab === 'cockpit') return <WorkspaceGeneralView />;
  if (tab === 'users') return <AdminUsersSection />;
  if (tab === 'sso') return <ListIntegrations />;
  return null;
}
